/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Construct from 'can/construct/construct';

export default Construct.extend({
    makeShortTeamPlayerNames: function (str) {
        var names = str.split('/');
        var shortNames = [];

        for (var i = 0, len = names.length; i < len; i++) {
            shortNames.push(this.makeShortPlayerName(names[i]));
        }

        return shortNames.join(' / ');
    },

    makeShortPlayerName: function (name) {
        var parts;
        var firstName = '';
        var lastName = '';
        var isAmateur = false;
        var suffix = '';

        if (name) {
            name = this.swapAbbr(name.trim());
            suffix = this.getSuffix(name);

            if (this.getAmateur(name)) {
                isAmateur = true;
                name = this.cutAmateur(name);
            }

            if (suffix) {
                name = this.cutSuffix(name);
            }

            parts = name.replace(/^[\s-]+|[\s-]+$/g, '').split(/\s+|-+|\.(?=[A-Za-z])/);
            lastName = parts[parts.length - 1];

            for (var i = 0, len = parts.length - 1; i < len; i++) {
                var namePart = parts[i];

                namePart = namePart.charAt(0) + '.';
                firstName = firstName + namePart;
            }
        }

        return firstName + ' ' + lastName + (suffix ? ' ' + suffix + ' ' : '') + (isAmateur ? ' (a)' : '');
    },

    swapAbbr: function (name) {
        var pattern = /\s([a-z]\.*)((\.|\s)[a-z]\.*)\s*$/i;

        if (pattern.test(name)) {
            var matched = pattern.exec(name);
            name = matched[0].trim() + ' ' + name.replace(pattern, '').trim();
        }

        return name;
    },

    getAmateur: function (name) {
        var amateurMatch = /\(a\)$/ig.exec(name);

        if (amateurMatch) {
            return amateurMatch[0];
        }

        return '';
    },

    cutAmateur: function (name) {
        var amateur = this.getAmateur(name);

        if (amateur) {
            return name.replace(/\(a\)$/ig, '');
        }

        return name;
    },

    getSuffix: function (name) {
        var suffixMatch = /((sr|jr)\.*|\s(i|ii|iii|iv|v)\.*)\s*$/ig.exec(name);

        if (suffixMatch) {
            return suffixMatch[0];
        }

        return '';
    },

    cutSuffix: function (name) {
        var suffix = this.getSuffix(name);

        if (suffix) {
            return name.replace(/((sr|jr)\.*|\s(i|ii|iii|iv|v)\.*)\s*$/ig, '');
        }

        return name;
    },

    getDisplayName: function (name) {
        var isAmateur = false;
        var suffix = '';

        if (name !== '') {
            var nameParts = name.split(',');

            for (var i = 0, len = nameParts.length; i < len; i++) {
                var part = nameParts[i].trim();
                var partSuffix = this.getSuffix(part);

                if (this.getAmateur(part)) {
                    isAmateur = true;
                    nameParts[i] = this.cutAmateur(part);
                }

                if (partSuffix) {
                    suffix = partSuffix;
                    nameParts[i] = this.cutSuffix(part);
                }
            }

            var firstName = nameParts[1] ? nameParts[1].trim() : '';
            var lastName = nameParts[0] ? nameParts[0].trim() : '';

            return firstName + ' ' + lastName + (suffix ? ' ' + suffix + ' ' : '') + (isAmateur ? ' (a)' : '');
        }

        return '';
    }
}, {});
